module.exports = __webpack_public_path__ + "static/media/PO.748ecc80.svg";